import React from 'react';
import { Rocket, AlertCircle } from 'lucide-react';
import { Button } from '@/components/Button';

interface Props {
  adSetCount: number;
  adCount: number;
  onConfirm: () => void;
  onCancel: () => void;
  isPublishing: boolean;
}

export const ActivateDialog: React.FC<Props> = ({ adSetCount, adCount, onConfirm, onCancel, isPublishing }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
    <div className="bg-surface-elevated rounded-2xl border border-border shadow-elevated w-full max-w-sm p-6 space-y-5">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-warning-soft text-warning">
          <AlertCircle size={20} />
        </div>
        <h3 className="font-display font-semibold text-text-primary">Activate campaign?</h3>
      </div>

      <p className="text-sm text-text-secondary">
        This will switch <strong>{adSetCount} ad set{adSetCount !== 1 ? 's' : ''}</strong> and <strong>{adCount} ad{adCount !== 1 ? 's' : ''}</strong> to ACTIVE status.
        <span className="block mt-1 text-warning font-medium">Charges will start immediately.</span>
      </p>

      <div className="flex gap-2 justify-end">
        <Button variant="secondary" size="sm" onClick={onCancel} disabled={isPublishing}>
          Cancel
        </Button>
        <Button
          variant="primary"
          size="sm"
          loading={isPublishing}
          onClick={onConfirm}
          iconLeft={<Rocket size={13} />}
        >
          Activate
        </Button>
      </div>
    </div>
  </div>
);
